export default __webpack_public_path__ + "static/media/Document.1a4fedba.svg";